import axios from "axios";
import * as routerConfig from "./data/conf.json";

export const HttpModule = {
  CreatePolling: async (content) => {
    try {
      const response = await axios.post(routerConfig.base + routerConfig.pollingCreate,  { content: content })
      return response;
    }
    catch(e) {
      throw new Error(e);
    }
  },
  GetDates: async (turnType) => {
    try {
      const tt = Number(turnType);
      const response = await axios.post(
        routerConfig.base + routerConfig.getTurns,
        { turnType: tt }
      );
      const data = response.data;
      if (data.status) return data.data;
      else new Error(data.code);
    } catch (err) {
      throw new Error(err);
    }
  },

  SubmitNewTest: async (data) => {
    try {
      const response = await axios.post(
        routerConfig.base + routerConfig.addNewTest,
        data
      );
      if (response.status === 200) return true;
      else return false;
    } catch (e) {
      throw new Error(e);
    }
  },

  UpdateData: async (info) => {
    return axios.post(routerConfig.base + routerConfig.updateData, info);
  },
  SubmitReservation: async (reservationId, UserInfo) => {
    try {
      if (!reservationId || !UserInfo) throw new Error("Invalid Parameter");
      const response = await axios.post(
        routerConfig.base + routerConfig.registerReservation,
        {
          reservationId,
          UserInfo,
        }
      );
      return response.data;
    } catch (e) {
      throw new Error(e);
    }
  },
  SubmitTestData: async (data) => {
    try {
      if (typeof data === "object") {
        const response = await axios.post(
          routerConfig.base + routerConfig.SubmitTest,
          {
            data,
          }
        );

        return response.data;
      } else throw new Error("Invalid Data Type");
    } catch (e) {
      throw new Error(e);
    }
  },
  SubmitMbtiTest: async (data) => {
    try {
      const response = await axios.post(
        routerConfig.base + routerConfig.SubmitMbti,
        data,
        {
          timeout: 5000,
        }
      );

      if (response.data.status) return true;
      else return Promise.reject(false);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  GetGallary: async () => {
    try {
      const url = routerConfig.base + routerConfig.galleryFetchData;
      const response = await axios.post(
        url,
        {},
        {
          timeout: 3000,
        }
      );
      return response.data;
    } catch (error) {
      return Promise.reject(false);
    }
  },
};

export const HTTP_PROGRESS = {
  DONE: "done",
  PENDING: "pending",
  FAILED: "failed",
};

export default HttpModule;
